__turbopack_context__.v({
  "SettingsCloseButton": "VndlyAlert-module-scss-module__IFa8va__SettingsCloseButton",
  "SettingsHeader": "VndlyAlert-module-scss-module__IFa8va__SettingsHeader",
  "SettingsPopup": "VndlyAlert-module-scss-module__IFa8va__SettingsPopup",
  "SettingsTitle": "VndlyAlert-module-scss-module__IFa8va__SettingsTitle",
  "VndlyAlert__danger_confirmBtn": "VndlyAlert-module-scss-module__IFa8va__VndlyAlert__danger_confirmBtn",
  "VndlyAlert__warn_confirmBtn": "VndlyAlert-module-scss-module__IFa8va__VndlyAlert__warn_confirmBtn",
  "VndlyAlert_cancelBtn": "VndlyAlert-module-scss-module__IFa8va__VndlyAlert_cancelBtn",
  "VndlyAlert_confirmBtn": "VndlyAlert-module-scss-module__IFa8va__VndlyAlert_confirmBtn",
  "VndlyAlert_container": "VndlyAlert-module-scss-module__IFa8va__VndlyAlert_container",
  "VndlyAlert_popup": "VndlyAlert-module-scss-module__IFa8va__VndlyAlert_popup",
  "VndlyToast_container": "VndlyAlert-module-scss-module__IFa8va__VndlyToast_container",
  "VndlyToast_icon": "VndlyAlert-module-scss-module__IFa8va__VndlyToast_icon",
  "VndlyToast_popup": "VndlyAlert-module-scss-module__IFa8va__VndlyToast_popup",
  "VndlyToast_popup__success": "VndlyAlert-module-scss-module__IFa8va__VndlyToast_popup__success",
  "VndlyToast_title__success": "VndlyAlert-module-scss-module__IFa8va__VndlyToast_title__success",
});
